const currencyCountryMap2 = {
    USD: "us",    // USA
    EUR: "eu"     // Europe
};

export default currencyCountryMap2;